import React, { useEffect, useRef } from 'react';
import { MdClose, MdSearch } from 'react-icons/md';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const SearchBar = ({ value, onChange, onSubmit, isSearching = false, onClear, className = '' }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const searchTimeoutRef = useRef(null);

  const handleChange = (newValue) => {
    onChange(newValue);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (newValue) {
      searchTimeoutRef.current = setTimeout(() => {
        if (onSubmit) onSubmit();
      }, 500);
    } else if (onSubmit) onSubmit();
  };

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const handleClear = () => {
    if (!value) return; // Prevent unnecessary clear if already empty

    onChange('');
    if (onClear) onClear();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className={classNames('relative w-full', className)}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (onSubmit) onSubmit();
        }}
        className="w-full"
      >
        <div className="relative">
          <input
            ref={inputRef}
            type="text" // Ubah dari "search" menjadi "text"
            className={classNames(
              'w-full py-2 pl-10 pr-4 text-sm border rounded-lg transition-all duration-200',
              'bg-white border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
              { 'pr-10': value }
            )}
            placeholder={t('search_event_placeholder', 'Cari acara...')}
            value={value}
            onChange={(e) => handleChange(e.target.value)}
          />
          {/* Search icon */}
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <MdSearch
              className={classNames('w-5 h-5 transition-all duration-200', {
                'text-primary-500': value,
                'text-gray-400': !value,
              })}
            />
          </div>

          {/* Clear button - only shown when there's input */}
          {value && (
            <button
              type="button"
              className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 hover:text-gray-700"
              onClick={handleClear}
              aria-label="Clear search"
            >
              <MdClose className="w-4 h-4" />
            </button>
          )}
        </div>
      </form>

      {/* Loading indicator - subtle pulse effect */}
      {isSearching && value && (
        <div className="absolute bottom-0 left-0 h-0.5 bg-primary-500 animate-pulse w-full" />
      )}
    </div>
  );
};

export default SearchBar;
